export default function WhatHappensNext() {
  const steps = [
    {
      number: 1,
      title: 'Application Submitted',
      description: 'Your application is received and queued for review',
      icon: 'ri-file-check-line',
      color: 'teal',
      time: 'Instant'
    },
    {
      number: 2,
      title: 'Document Verification',
      description: 'Our team reviews your ID, CSCS card, and other documents',
      icon: 'ri-shield-check-line',
      color: 'blue',
      time: '24-48 hours'
    },
    {
      number: 3,
      title: 'Background Check',
      description: 'We verify your credentials and work history',
      icon: 'ri-search-eye-line',
      color: 'purple',
      time: '1-2 days'
    },
    {
      number: 4,
      title: 'Approval & Activation',
      description: 'You receive approval email and can start accepting jobs',
      icon: 'ri-checkbox-circle-line',
      color: 'green',
      time: '1-3 days total'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#0B3C5D] to-[#328BA8] rounded-2xl mb-4 shadow-lg">
          <i className="ri-roadmap-line text-3xl text-white"></i>
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">What Happens Next?</h3>
        <p className="text-gray-600">Your journey to becoming a verified Taskbudy provider</p>
      </div>

      <div className="space-y-6">
        {steps.map((step, index) => (
          <div key={step.number} className="relative">
            {/* Connecting Line */}
            {index < steps.length - 1 && (
              <div className="absolute left-6 top-16 w-0.5 h-12 bg-gradient-to-b from-gray-300 to-gray-200"></div>
            )}

            <div className="flex items-start gap-4">
              {/* Icon */}
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md ${
                  step.color === 'teal'
                    ? 'bg-teal-500'
                    : step.color === 'blue'
                    ? 'bg-blue-500'
                    : step.color === 'purple'
                    ? 'bg-purple-500'
                    : 'bg-green-500'
                }`}
              >
                <i className={`${step.icon} text-white text-2xl`}></i>
              </div>

              {/* Content */}
              <div className="flex-1 bg-white rounded-xl p-5 border border-gray-200 hover:shadow-md transition-all duration-300">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs font-bold text-gray-500">STEP {step.number}</span>
                      <span
                        className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                          step.color === 'teal'
                            ? 'bg-teal-100 text-teal-700'
                            : step.color === 'blue'
                            ? 'bg-blue-100 text-blue-700'
                            : step.color === 'purple'
                            ? 'bg-purple-100 text-purple-700'
                            : 'bg-green-100 text-green-700'
                        }`}
                      >
                        {step.time}
                      </span>
                    </div>
                    <h4 className="font-bold text-gray-900 text-lg mb-1">{step.title}</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Summary */}
      <div className="mt-8 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-xl p-6 border border-teal-200">
        <div className="flex items-start gap-3">
          <i className="ri-time-line text-2xl text-teal-600 mt-1"></i>
          <div>
            <h4 className="font-bold text-gray-900 mb-2">Total Timeline: 1-3 Business Days</h4>
            <p className="text-sm text-gray-700 leading-relaxed">
              Most applications are approved within 24-48 hours. You'll receive email notifications at each stage, and you can track your application status in your dashboard.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
